import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { imageApi } from './../../config'
import bemClass from './../../utils/bemClass'

import './Image.css'

const cn = bemClass('Image')

class Image extends PureComponent {
    state = { loaded: false, placeholderLoaded: false, blurUp: false }
    timeout = null

    handleLoad = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(this.checkBlurUp, 2000)
        this.setState({ loaded: true })
    }

    handlePlaceholderLoad = () => this.setState({ placeholderLoaded: true })

    checkBlurUp = () => {
        const { loaded, blurUp } = this.state

        if (loaded !== blurUp) {
            return
        }

        return this.setState({ blurUp: !loaded })
    }

    imgStyle = () => {
        const { width, height } = this.props

        let result = {}
        if (!!width) {
            result = {
                width: `${width}px`,
            }
        }

        if (!!height) {
            result = {
                height: `${height}px`,
            }
        }

        return result
    }

    imgUrl = () => {
        const { width, height, src } = this.props

        return `${imageApi}${src}/${width || ''}x${height || ''}`
    }

    placeholderUrl = size => {
        const { width, height, src } = this.props
        const placeholderWidth = Math.min(
            size,
            !!width ? Math.ceil(width / 25) : size
        )
        const placeholderHeight =
            width && height ? Math.ceil(placeholderWidth * height / width) : ''

        return `${imageApi}${src}/${placeholderWidth ||
            ''}x${placeholderHeight || ''}`
    }

    componentDidMount() {
        this.timeout = setTimeout(this.checkBlurUp, 50)
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    render() {
        const {
            className,
            containerClassName,
            placeholderClassName,
            alt,
            noBlurUp,
        } = this.props
        const { loaded, placeholderLoaded, blurUp } = this.state
        const imgStyle = this.imgStyle()
        const placeholderUrl = this.placeholderUrl(50)

        return (
            <div className={`${cn()} ${containerClassName}`}>
                {!noBlurUp && blurUp && (
                    <img
                        key={`${placeholderUrl}-2`}
                        src={placeholderUrl}
                        className={`${cn('placeholder', {
                            backgrounder: true,
                            placeholderLoaded,
                            loaded,
                        })} ${placeholderClassName}`}
                        alt="background"
                        onLoad={this.handlePlaceholderLoad}
                    />
                )}
                {!noBlurUp && blurUp && (
                    <img
                        key={placeholderUrl}
                        src={placeholderUrl}
                        className={`${cn('placeholder', {
                            placeholderLoaded,
                            loaded,
                        })} ${placeholderClassName}`}
                        alt="placeholder"
                        onLoad={this.handlePlaceholderLoad}
                    />
                )}
                <img
                    key={this.imgUrl()}
                    src={this.imgUrl()}
                    style={imgStyle}
                    className={`${className} ${cn('image', {
                        loaded,
                        blurUp,
                    })}`}
                    alt={alt}
                    onLoad={this.handleLoad}
                />
            </div>
        )
    }
}

Image.propTypes = {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    placeholderClassName: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    noBlurUp: PropTypes.bool,
}

Image.defaultProps = {
    className: '',
    containerClassName: '',
    placeholderClassName: '',
    noBlurUp: false,
}

export default Image



// WEBPACK FOOTER //
// ./src/components/Image/Image.jsx